export default __webpack_public_path__ + "static/media/hero.0eaa068f.png";